import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { redirectAction } from "../Actions/CommonActions";
import { getDecryptedItem } from "../../../utils/localStorageHelper";

const RedirectConnectionPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const locSearch = new URLSearchParams(location.search);
  const code = locSearch.get("code");
  const authType = locSearch.get("authType");
  const projectId = getDecryptedItem("projectId");

  useEffect(() => {
    const init = async () => {
      const params = {
        code,
        projectId,
        type: authType,
      };

      await dispatch(redirectAction(params));
      history.push(`/account/project/${projectId}/integrations`);
    };
    init();
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 5,
      }}
    >
      <Box className="font-14-600-grey">Redirecting...</Box>
    </Box>
  );
};

export default RedirectConnectionPage;
